import { Quote } from 'components/Quote'
import { ReactNode } from 'react'

export const content_international: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link?: number
}[] = [
  {
    title: 'Wie lange dauert die Putin-Ära noch?',
    author: 'Zita Affentranger',
    autorBio: '15616033/zita-affentranger',
    content: (
      <>
        <p>
          Seine Zeit läuft ab, das lässt sich mit Sicherheit sagen. Schon zu
          Beginn des Ukraine-Kriegs war klar, dass dieser grausame, wider alle
          Vernunft vom Zaun gebrochene Krieg Wladimir Putin politisch Kopf und
          Kragen kosten wird. Doch diejenigen, die hofften, ihn mit scharfen
          Wirtschaftssanktionen zum Einlenken in der Ukraine zu zwingen, hängen
          einem alten Denkfehler an und haben die Lektion der Strafrunde nach
          der Annexion der ukrainischen Krim 2014 nicht gelernt: Je mehr Druck
          von aussen auf das russische Volk ausgeübt wird, desto besser geht es
          Putin zu Hause – schuld an der Misere sind schliesslich die anderen.
        </p>
        <p>
          Sanktionen sind natürlich trotzdem unumgänglich, schon aus Prinzip.
          Und sie ändern auf die Dauer sicher auch etwas in der russischen
          Elite, die ihre Felle – oder ihre Jachten – davonschwimmen sieht. Am
          Krieg in der Ukraine dürfte aber nur der Abgang Putins etwas ändern.
          Putinkritische russische Kommentatoren sind überzeugt, dass die Kämpfe
          danach sehr schnell aufhören werden. Die wirkliche Gefahr erwächst
          Putin dabei aus dem für Russland schlechten Kriegsverlauf: Seit der
          Teilmobilmachung sinkt die Begeisterung von Russinnen und Russen für
          den Krieg und damit auch für den Kriegsherren. Die Niederlagen gegen
          die lange verlachte ukrainische Armee passen nicht zum Bild des
          allmächtigen und siegreichen Zaren.
        </p>
        <Quote>Wie kann die Nation neu und frei aufgebaut werden?</Quote>
        <p>
          Für die russische Opposition ist der Abgang des ewigen Präsidenten
          inzwischen so klar, dass sie kaum noch über ihn reden, sondern vor
          allem über ein Russland ohne Putin debattieren: Wie kann die Nation
          neu und frei aufgebaut werden? Der Kremlkritiker Michail Chodorkowski
          etwa hat gerade eine Art Anleitung zur Revolution geschrieben mit dem
          Titel: «Wie man einen Drachen tötet».
        </p>
        <p>Niemand hat einen Zeitplan, doch die Endzeit hat begonnen.</p>
      </>
    ),
    link: 731579342915,
  },
  {
    title: 'Gewinnt China den Systemwettbewerb gegen den Westen?',
    author: 'Sandro Benini',
    autorBio: '67673331/sandro-benini',
    content: (
      <>
        <p>
          Unter den autoritären, antiliberalen Ländern, die dem Westen einen
          globalen Systemwettbewerb liefern, hat China sicher die besten Chancen
          auf einen Sieg. Dies, weil es China in den letzten 30 Jahren gelungen
          ist, was viele zuvor für strukturell unmöglich gehalten haben: die
          Fusion von Kapitalismus und Marktwirtschaft auf der einen mit einem
          diktatorischen Einparteiensystem auf der anderen Seite.
        </p>
        <p>
          Der gigantische Binnenmarkt, die disziplinierte Bevölkerung (auch wenn
          das teilweise ein Klischee ist), die Schnelligkeit beim Aufbau einer
          modernen Infrastruktur, gegen die es viel weniger ökologisch oder
          sonstwie motivierte Einsprachemöglichkeiten gibt als bei uns – das
          sind nur einige chinesische Vorteile im Systemwettbewerb. Hinzu kommt,
          dass China die Grundsätze einer liberalen internationalen
          Handelspolitik, die zu seinem Aufstieg beigetragen haben,
          ausländischen Unternehmen zumindest teilweise verweigert.
        </p>
        <Quote>
          Zu Beginn eines neuen Jahres soll man sich etwas Optimismus leisten.
          Die Demokratie wird über den Autoritarismus triumphieren.
        </Quote>
        <p>
          Dennoch sei hier die These gewagt, dass China den Systemwettbewerb
          gegen den Westen langfristig verlieren wird. Zum einen, weil das
          chinesische Wirtschaftswunder nicht zuletzt auf einer hochriskanten
          Verschuldungspolitik beruht und weil die chinesische Gesellschaft
          rapide altert. Zum anderen – und das ist langfristig der wichtigere
          Faktor –, weil der implizite Pakt zwischen Diktatur und Bevölkerung
          brüchig ist, der besagt: Wir sorgen für Wohlstand, Ruhe und Ordnung,
          ihr verzichtet dafür auf politische Freiheit. Wie brüchig, haben die
          jüngsten Unruhen wegen der brutalen Anti-Corona-Politik gezeigt. Der
          amerikanische Politologe Francis Fukuyama hat recht, wenn er schreibt,
          China habe wenig internationale Anziehungskraft, die über das rein
          Ökonomische hinausgehe. Es gebe kaum jemanden, der nach China
          auswandern oder dort Staatsbürgerin oder Staatsbürger werden wolle.
        </p>
        <p>
          Zu Beginn eines neuen Jahres soll man sich etwas Optimismus leisten.
          Die Demokratie wird über den Autoritarismus triumphieren, weil sie
          neben materiellen auch politische und geistige Bedürfnisse abdeckt,
          die urmenschlich sind.
        </p>
      </>
    ),
    link: 157085405523,
  },
]
